<div class="getting-started-checklist-container">
  <h2>Getting Started Checklist</h2>
  <p>
    Complete the tasks in the checklist to ensure that accounts and license
    assignments are ready before the start of the school year.
  </p>
  <ul>
    @for (item of checkListData; track item.label; let i = $index) {
      <li>
        <zbp-button-component
          [internalId]="'checkItem_' + i"
          [theme]="item.isComplete ? 'tealSolid' : 'tealGhost'"
          (clickHandler)="clickItem(item)"
          [iconName]="getIcon(item.isComplete)"
          iconPosition="left"
          iconSize="font-size"
          [label]="item.label"
          [role]="item.role"
          [ariaLabel]="item.isComplete ? item.label + ', Completed' : item.label + ', Incomplete'"
        ></zbp-button-component>
      </li>
    }
  </ul>
</div>
